import type { App } from '@grafikr/components';

import intersectionLoader from 'utils/loaders/intersection';

export default (app: App) => {
  app.add({
    'v2-countdown': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-v2-countdown" */ 'components/v2-countdown'),
    ],
    'v2-homepage-link': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-v2-homepage-link" */ 'components/v2-homepage-link'),
    ],
  });
};
